import React from "react";

// Lightweight CSS ring spinner. Replaces react-loading-indicators, which was a
// whole dependency pulled in only for a loading animation.
const Spinner = ({ size = 32, label }) => (
    <div className="flex flex-col items-center justify-center gap-2 py-4 text-emp">
        <span
            role="status"
            aria-label={label || "Loading"}
            className="inline-block rounded-full border-2 border-current border-t-transparent animate-spin"
            style={{ width: size, height: size }}
        />
        {label && <span className="text-sm">{label}</span>}
    </div>
);

export default Spinner;
